/* Massa Gomme: disponibilita per intervallo, 2026-09-25 */
(() => {
  const API = 'https://massagomme-renthub-bridge.vercel.app/api/availability';
  const MODELS = {24:1,16:2,23:3,20:4,22:5,13:6,18:7,5:8,21:9,8:10,9:12,11:13,19:14,3:15,15:16,14:17,10:18,7:19};
  const TTL = 20000;
  const ids = ['pickup-date','pickup-time','return-date','return-time'];
  const fields = ['pickup','pickupTime','returnDate','returnTime'];
  const value = id => document.getElementById(id)?.value || '';
  const period = (detail = {}) => Object.fromEntries(fields.map((name, i) => [name, detail[name] ?? value(ids[i])]));
  const keyOf = p => fields.map(name => p[name]).join('|');
  const currentKey = () => keyOf(period());
  const valid = p => fields.every(name => p[name]) && `${p.returnDate} ${p.returnTime}` > `${p.pickup} ${p.pickupTime}`;
  const selected = () => Number((document.querySelector('.vehicle-picker-title')?.textContent || '').match(/N\.?\s*(\d+)/i)?.[1]) || null;
  const empty = () => Object.fromEntries(Object.values(MODELS).map(n => [n, null]));
  const tags = new WeakMap();
  let active = null, state = {key:'', phase:'idle', map:empty(), at:0}, serial = 0, timer;
  const tagged = (map, key) => { tags.set(map, key); return map; };
  const message = () => {
    if (state.key !== currentKey() || state.phase === 'idle') return 'Seleziona date e orari validi per verificare la disponibilita.';
    if (state.phase === 'loading') return 'Controllo disponibilita reale su RentHub in corso...';
    if (state.phase === 'error') return 'Collegamento RentHub momentaneamente non riuscito. Premi AGGIORNA DISPONIBILITA per riprovare.';
    const n = selected(), available = state.map[n];
    if (!n) return 'Disponibilita aggiornata da RentHub per le date e gli orari selezionati.';
    return available === true ? `Furgone N.${n}: DISPONIBILE per le date e gli orari selezionati.` : available === false ? `Furgone N.${n}: OCCUPATO / NON DISPONIBILE. Scegli un mezzo libero nelle alternative.` : `Furgone N.${n}: non prenotabile online per questo intervallo.`;
  };
  function render() {
    const ready = state.key === currentKey() && state.phase === 'ready' && Date.now() - state.at < TTL;
    const n = selected(), allowed = ready && state.map[n] === true;
    const status = document.getElementById('km-status');
    if (status) status.textContent = message();
    const wa = document.getElementById('km-wa-btn');
    if (wa) {
      wa.setAttribute('aria-disabled', allowed ? 'false' : 'true');
      wa.classList.toggle('renthub-blocked', !allowed);
      wa.textContent = allowed ? 'RICHIEDI CONFERMA SU WHATSAPP' : state.phase === 'loading' ? 'VERIFICA IN CORSO...' : ready && state.map[n] === false ? 'MEZZO OCCUPATO: SCEGLI UN ALTERNATIVO' : 'VERIFICA PRIMA LA DISPONIBILITA';
    }
    const retry = document.getElementById('renthub-refresh');
    if (retry) retry.disabled = state.phase === 'loading';
    if (state.phase !== 'ready') {
      const label = state.phase === 'loading' ? 'Verifica in corso...' : state.phase === 'error' ? 'Collegamento da riprovare' : 'Seleziona date e orari';
      document.querySelectorAll('.availability-badge').forEach(b => { b.textContent = label; b.className = 'availability-badge'; });
      const panel = document.querySelector('.vehicle-status-panel');
      if (panel && n) {
        panel.hidden = false;
        const title = panel.querySelector('strong'), help = panel.querySelector('small');
        if (title) title.textContent = label;
        if (help) help.textContent = message();
      }
    }
  }
  function publish(map) {
    if (typeof window.MASSAGOMME_SET_AVAILABILITY === 'function') window.MASSAGOMME_SET_AVAILABILITY(tagged({...map}, state.key));
    setTimeout(render, 0);
  }
  async function check(detail = {}, force = false) {
    const p = period(detail), key = keyOf(p);
    if (key !== currentKey()) throw new Error('STALE_RENTHUB_PERIOD');
    if (!valid(p)) {
      serial++; active?.controller.abort(); active = null;
      state = {key, phase:'idle', map:empty(), at:0}; publish(state.map);
      return tagged(empty(), key);
    }
    if (active?.key === key) return active.promise;
    if (!force && state.key === key && state.phase === 'ready' && Date.now() - state.at < TTL) {
      publish(state.map); return tagged({...state.map}, key);
    }
    const generation = ++serial;
    active?.controller.abort();
    const controller = new AbortController();
    state = {key, phase:'loading', map:empty(), at:0}; publish(state.map);
    const promise = (async () => {
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const params = new URLSearchParams({start_datetime:`${p.pickup} ${p.pickupTime}`,end_datetime:`${p.returnDate} ${p.returnTime}`,pickup_location:'1',dropoff_location:'1',category:'2',type:'2',age:'30',lang:'it_IT'});
        const response = await fetch(`${API}?${params}`, {headers:{Accept:'application/json'},cache:'no-store',signal:controller.signal});
        if (!response.ok) throw new Error(`RENTHUB_HTTP_${response.status}`);
        const payload = await response.json(), result = payload?.data?.result;
        if (payload?.ok !== true || payload?.data?.status !== true || !Array.isArray(result?.vehicles)) throw new Error('INCOMPLETE_RENTHUB_RESPONSE');
        if (result.start !== `${p.pickup} ${p.pickupTime}` || result.end !== `${p.returnDate} ${p.returnTime}`) throw new Error('RENTHUB_PERIOD_MISMATCH');
        const map = empty();
        for (const row of result.vehicles) {
          const n = MODELS[Number(row?.model_id ?? row?.model_details?.id)];
          if (n && typeof row.available === 'boolean') map[n] = row.available;
        }
        if (!result.vehicles.length) Object.keys(map).forEach(n => { map[n] = false; });
        else if (!Object.values(map).some(v => typeof v === 'boolean')) throw new Error('NO_MAPPED_VEHICLES');
        if (generation !== serial || key !== currentKey()) throw new Error('STALE_RENTHUB_PERIOD');
        state = {key, phase:'ready', map, at:Date.now()}; publish(map);
        return tagged({...map}, key);
      } catch (error) {
        if (generation !== serial || key !== currentKey()) throw new Error('STALE_RENTHUB_PERIOD');
        state = {key, phase:'error', map:empty(), at:0}; publish(state.map);
        console.warn('RentHub availability:', error.message);
        return tagged(empty(), key);
      } finally {
        clearTimeout(timeout);
        if (active?.generation === generation) active = null;
      }
    })();
    active = {key, generation, controller, promise};
    return promise;
  }
  window.MASSAGOMME_RENTHUB_CHECK = check;
  const refresh = force => check({}, force).catch(() => {});
  function mount() {
    const previous = window.MASSAGOMME_SET_AVAILABILITY;
    window.MASSAGOMME_SET_AVAILABILITY = map => {
      if (!map || tags.get(map) !== currentKey()) return;
      if (typeof previous === 'function') previous(map);
      setTimeout(render, 0);
    };
    const status = document.getElementById('km-status');
    if (status && !document.getElementById('renthub-refresh')) {
      const button = document.createElement('button'); button.id = 'renthub-refresh'; button.type = 'button'; button.className = 'btn blackbtn'; button.textContent = 'AGGIORNA DISPONIBILITA';
      button.addEventListener('click', () => refresh(true)); status.insertAdjacentElement('beforebegin', button);
    }
    const style = document.createElement('style'); style.textContent = '#km-wa-btn.renthub-blocked{opacity:.6;cursor:not-allowed}#renthub-refresh{margin:10px 0;max-width:100%;white-space:normal}'; document.head.appendChild(style);
    const wa = document.getElementById('km-wa-btn');
    if (wa) {
      let savedHref = wa.getAttribute('href') || '';
      const syncLink = () => {
        const href = wa.getAttribute('href');
        if (href && href !== '#') savedHref = href;
        const allowed = state.key === currentKey() && state.phase === 'ready' && state.map[selected()] === true && Date.now() - state.at < TTL;
        if (!allowed && href !== null) wa.removeAttribute('href');
        if (allowed && !href && savedHref) wa.setAttribute('href', savedHref);
        if (wa.getAttribute('aria-disabled') !== String(!allowed)) wa.setAttribute('aria-disabled', String(!allowed));
      };
      new MutationObserver(syncLink).observe(wa, {attributes:true,attributeFilter:['href','aria-disabled']});
      syncLink();
    }
    refresh(false);
  }
  document.addEventListener('change', event => {
    if (!ids.includes(event.target.id)) return;
    serial++; active?.controller.abort(); active = null;
    state = {key:currentKey(), phase:'idle', map:empty(), at:0}; publish(state.map);
    clearTimeout(timer); timer = setTimeout(() => refresh(false), 0);
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest?.('#km-wa-btn,.js-wa-card,.vehicle-option,.alternative-select,#km-calc-btn');
    if (!target) return;
    if (target.matches('#km-wa-btn')) {
      if (state.key !== currentKey() || state.phase !== 'ready' || state.map[selected()] !== true || Date.now() - state.at >= TTL) {
        event.preventDefault(); event.stopImmediatePropagation(); refresh(false); return;
      }
    } else if (target.matches('.js-wa-card')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const card = target.closest('article'), src = card?.querySelector('img')?.src || '', n = Number(src.match(/flotta-(\d+)\.jpg/i)?.[1]);
      const option = [...document.querySelectorAll('.vehicle-option')].find(el => Number((el.querySelector('img')?.src || '').match(/flotta-(\d+)\.jpg/i)?.[1]) === n);
      option?.click(); document.getElementById('km-calculator')?.scrollIntoView({behavior:'smooth'});
    }
    setTimeout(() => refresh(false), 0);
  }, true);
  window.addEventListener('online', () => refresh(true));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(false); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
})();

;
// MassaGomme: catalogo condiviso con l'app privata, 2026-09-26
(()=>{
  const origin="https://massagomme-rent-private.cavallopazzo.chatgpt.site";
  function mount(){
    if(document.getElementById("massagomme-shared-fleet"))return;
    const old=document.getElementById("km-calculator");if(!old)return;
    const wrapper=document.createElement("div");wrapper.id="massagomme-shared-fleet";
    const frame=document.createElement("iframe");frame.src=origin+"/flotta/ricerca";frame.title="Ricerca furgoni MassaGomme con disponibilità RentHub";frame.style.cssText="width:100%;height:950px;border:0;display:block;background:white";frame.loading="eager";
    const fallback=document.createElement("a");fallback.href=frame.src;fallback.target="_blank";fallback.rel="noopener";fallback.textContent="Apri la ricerca furgoni in una nuova pagina";fallback.style.cssText="display:block;text-align:center;padding:12px;font-size:13px";
    wrapper.append(frame,fallback);old.insertAdjacentElement("afterend",wrapper);
    window.addEventListener("message",event=>{if(event.origin!==origin||event.source!==frame.contentWindow||event.data?.type!=="massagomme-fleet-height")return;const height=Number(event.data.height);if(Number.isFinite(height)&&height>=200&&height<=50000)frame.style.height=Math.ceil(height)+"px";});
    const style=document.createElement("style");style.textContent="#km-calculator,#size-guide,#flotta-legacy,.gallery{display:none!important}#massagomme-shared-fleet{width:100%;scroll-margin-top:80px}";document.head.appendChild(style);
    const legacyFleet=document.getElementById("flotta");if(legacyFleet){legacyFleet.id="flotta-legacy";const anchor=document.createElement("span");anchor.id="flotta";wrapper.prepend(anchor);}
  }
  document.readyState==="loading"?document.addEventListener("DOMContentLoaded",mount,{once:true}):mount();
})();
